'use client';

import { Icon } from '@onyx/ui/components/colleague/icon';
import { useRouter } from 'next/navigation';

import styles from './chatbot-entry-bar.module.css';

type ChatbotEntryBarProps = {
  placeholder: string;
};

export const ChatbotEntryBar = ({ placeholder }: ChatbotEntryBarProps) => {
  const router = useRouter();

  const handleClick = () => {
    router.push('/chatbot/new');
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.searchContainer}>
        <button
          type="button"
          className={styles.searchButton}
          onClick={handleClick}
          aria-label={placeholder}
        >
          <div className={styles.searchIcon}>
            <Icon name="Search" size={24} />
          </div>
          <span className={styles.placeholder}>{placeholder}</span>
        </button>
      </div>
    </div>
  );
};
